import React, { useCallback } from 'react';

import { App, Button, Tooltip } from 'antd';

import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import shoppingProductService from 'v2/services/shopping/product';

import CcbAlert from './ccbAlert';

interface GetCcbTermProps {
  delivery: ShoppingDelivery;
}

const GetCcbTerm = ({ delivery }: GetCcbTermProps) => {
  const { message } = App.useApp();
  const shouldShowButton = delivery.ccb;
  const handleClickDownload = useCallback(
    async (invoiceId: string) => {
      return shoppingProductService.getCcbTerm(invoiceId).subscribe({
        next: data => {
          const file = new File([data], `${invoiceId}.pdf`, {
            type: data.type
          });

          const url = URL.createObjectURL(file);
          const a = document.createElement('a');
          a.href = url;
          a.download = file.name;

          document.body.appendChild(a);
          a.click();

          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        },
        error: () => {
          message.error('Erro ao realizar download, tente novamente');
        }
      });
    },
    [message]
  );

  if (!shouldShowButton) {
    return <></>;
  }

  return (
    <>
      <CcbAlert />
      <Tooltip placement='top' title={!delivery.ccb ? 'Arquivo não disponível' : ''}>
        <div>
          <Button
            color='default'
            variant='filled'
            disabled={!delivery.ccb}
            onClick={() => handleClickDownload(delivery.invoice_id.toString())}
            block
          >
            Cédula de Crédito Bancário
          </Button>
        </div>
      </Tooltip>
    </>
  );
};

export default GetCcbTerm;
